module.exports = __webpack_public_path__ + "img/app-four-full-star.e235ea91.svg";